
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsArticleSeasonGrid extends Serenity.EntityGrid<CsArticleSeasonRow, any> {
        protected getColumnsKey() { return CsArticleSeasonColumns.columnsKey; }
        protected getDialogType() { return CsArticleSeasonDialog; }
        protected getIdProperty() { return CsArticleSeasonRow.idProperty; }
        protected getInsertPermission() { return CsArticleSeasonRow.insertPermission; }
        protected getLocalTextPrefix() { return CsArticleSeasonRow.localTextPrefix; }
        protected getService() { return CsArticleSeasonService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}